import React, { useCallback, useEffect, useRef, useState } from "react";
import { Markers } from "./Markers";
import useSupercluster from "use-supercluster";
import GoogleMap from "google-maps-react-markers";
import { ChevronLeftIcon, ChevronRightIcon } from "@radix-ui/react-icons";
import "./MapComponent.scss";
import LeadCard from "../LeadsCards";
import _ from "lodash";
import { mapStyles } from "../constants";
import FullScreenIcon from "./Icon/FullScreenIcon";
import MobileMapFullScreen from "../MobileMapFullScreen";
import AddLeadDetails from "../../Stepper/addNewLead/AddLeadDetails";
import LeadsValidForm from "../../vattenfallLeads/LeadsValidForm/LeadsValidForm";
const OpenMarker = ({
  items,
  setOpenMarker,
  openMarker,
  handleGetDashboardCount,
  setZoom,
}) => {
  const [index, setIndex] = useState(0);

  const onNext = () => {
    setIndex((prev) =>
      prev + 1 >= items.length ? items.length - 1 : prev + 1
    );
  };

  const onPrev = () => {
    setIndex((prev) => (prev - 1 < 0 ? 0 : prev - 1));
  };
  return (
    <div className="open-marker">
      <div className="grid-container">
        <LeadCard
          lead={items[index]}
          setOpenMarker={setOpenMarker}
          handleGetDashboardCount={handleGetDashboardCount}
          setZoom={setZoom}
          openMarker={openMarker}
        />

        <div className="navigation-controls">
          <div className="counter">{`${index + 1} Von ${items.length}`}</div>
          <button onClick={onPrev} className="control-button">
            <ChevronLeftIcon />
          </button>
          <button onClick={onNext} className="control-button">
            <ChevronRightIcon />
          </button>
        </div>
      </div>
    </div>
  );
};

export const MapComponent = ({
  center,
  classNameMap,
  leadsData,
  points,
  setOpenMarker,
  openMarker,
  setBounds,
  bounds,
  setZoom,
  zoom,
  map,
  setMap,
  searchLat,
  handleGetDashboardCount,
}) => {
  const [isMobileFullScreen, setIsMobileFullScreen] = useState(false);
  const [isLeadCreatedZoom, setIsLeadCreatedZoom] = useState(true);
  const zoomRef = useRef(zoom);
  const clickTimeoutRef = useRef(null);
  const [funnelSelectionData, setFunnelSelectionData] = useState({
    isFunnelMOdalOpen: false,
    locationData: null,
    previousMapState: null,
  });
  const [customCenter, setCustomCenter] = useState(center);

  const adjustedPoints = (() => {
    const coordinateMap = new Map();

    const data = leadsData?.forEach((f) => {
      const coordKey = `${f.locationCoordinates.coordinates[0]},${f.locationCoordinates.coordinates[1]}`;
      if (!coordinateMap.has(coordKey)) {
        coordinateMap.set(coordKey, []);
      }
      coordinateMap.get(coordKey).push(f);
    });

    const adjusted = [];
    const newdata = coordinateMap.forEach((points, key) => {
      if (points.length === 1) {
        adjusted.push({
          type: "Feature",
          properties: {
            id: points[0]?._id,
            ...points[0],
          },
          geometry: {
            type: "Point",
            coordinates: points[0].locationCoordinates.coordinates,
          },
        });
      } else {
        const pointCClusterData = points.forEach((point, index) => {
          const [lng, lat] = point.locationCoordinates.coordinates;
          const angle = (index / points.length) * Math.PI * 2;
          const radius = 0.0001; // about ~11m offset; tune if needed
          const offsetLng = lng + Math.cos(angle) * radius;
          const offsetLat = lat + Math.sin(angle) * radius;

          adjusted.push({
            type: "Feature",
            properties: {
              id: point._id,
              ...point,
            },
            geometry: {
              type: "Point",
              coordinates: [offsetLng, offsetLat],
            },
          });
        });
      }
    });

    return adjusted;
  })();

  useEffect(() => {
    const savedCenter = localStorage.getItem("mapCenter");
    const savedZoom = localStorage.getItem("mapZoom");
    const savedBounds = localStorage.getItem("mapBounds");
    
    if (savedCenter && savedZoom && map) {
      try {
        const parsedCenter = JSON.parse(savedCenter);
        const parsedZoom = Number(savedZoom);
        const parsedBounds = savedBounds ? JSON.parse(savedBounds) : null;

        setCustomCenter(parsedCenter);
        setZoom(parsedZoom);

        if (parsedBounds && map) {
          const bounds = new window.google.maps.LatLngBounds(
            new window.google.maps.LatLng(
              parsedBounds._southWest.lat,
              parsedBounds._southWest.lng
            ),
            new window.google.maps.LatLng(
              parsedBounds._northEast.lat,
              parsedBounds._northEast.lng
            )
          );

          const timer = setTimeout(() => {
            if (map && typeof map.fitBounds === "function") {
              map.fitBounds(bounds);
            }
          }, 100);

          return () => clearTimeout(timer);
        } else if (parsedCenter && map) {
          map.setCenter(parsedCenter);
          map.setZoom(parsedZoom);
        }
      } catch (error) {
        console.error("Error restoring map state:", error);
      }
    }
  }, [isLeadCreatedZoom, map]);
  const { clusters, supercluster } = useSupercluster({
    zoom,
    bounds: bounds
      ? [
          bounds.getSouthWest().lng(),
          bounds.getSouthWest().lat(),
          bounds.getNorthEast().lng(),
          bounds.getNorthEast().lat(),
        ]
      : undefined,
    points: adjustedPoints,
    // leadsData?.map((f) => ({
    //   type: "Feature",
    //   properties: {
    //     id: f?._id,
    //     ...f,
    //   },
    //   pintype: f?.funnel_type === "straper" ? "staper" : "vattenfall",
    //   geometry: {
    //     type: "Point",
    //     coordinates: [
    //       f.locationCoordinates.coordinates[0],
    //       f.locationCoordinates.coordinates[1],
    //     ],
    //   },
    // })) ?? [],
    options: {
      radius: 130,
      maxZoom: 20,
      minZoom: 3,
    },
    disableRefresh: !points,
  });

  const handleChange = useRef(
    _.throttle((e) => {
      zoomRef.current = e.zoom;
      setZoom(e.zoom);
      setBounds(e.bounds);
    }, 200)
  ).current;

  function getLeadColor(lead) {
    if (lead.newVattenMapLead || lead.newStraperMapLead) return "orange";
    if (lead.isDropDownLead === "dropdownLead") return "red";
    if (lead.myNewFlag) return "purple";
    if (lead.funnel_type === "straper") return "staper";
    if (lead.funnel_type === "heatpump") return "heatpump";
    return "vattenfall";
  }
  const handleFullScreen = () => {
    setIsMobileFullScreen(true);
  };
  const handleMapClick = useCallback(
    (e) => {
      if (clickTimeoutRef.current) {
        clearTimeout(clickTimeoutRef.current);
      }
      if (zoomRef.current < 18) return;

      clickTimeoutRef.current = setTimeout(() => {
        const latLng = e.latLng;
        if (!latLng) return;

        let locationData = {};
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: latLng }, (results, status) => {
          if (status === "OK" && results?.[0]) {
            const address = results[0]?.formatted_address;
            const center = latLng.toJSON();
            const isPostalCode = results[0]?.address_components.find((el) =>
              el?.types?.includes("postal_code")
            );
            if (isPostalCode?.long_name?.length === 5) {
              const isStreetNumber = results[0]?.address_components.find((el) =>
                el?.types?.includes("street_number")
              );
              const isLocality = results[0]?.address_components.find((el) =>
                el?.types?.includes("locality")
              );
              locationData = {
                adresse: address,
                nr: isStreetNumber?.long_name,
                ort: isLocality?.long_name,
                postleitzahl: isPostalCode?.long_name,
                locationCoordinates: center,
              };

              // Store current map state before opening the form
              const mapState = map ? {
                center: map.getCenter().toJSON(),
                zoom: map.getZoom(),
                bounds: map.getBounds()
              } : null;
              
              setFunnelSelectionData({
                isFunnelMOdalOpen: true,
                locationData: locationData,
                previousMapState: mapState
              });
            }
          } else {
            console.error("Geocode failed:", status);
          }
        });
      }, 50);
    },
    [setOpenMarker, map]
  );
  return (
    <>
      <div className="map-relative">
        <div className={`map-container ${classNameMap}`}>
          <GoogleMap
            defaultZoom={zoom}
            defaultCenter={customCenter}
            center={center}
            options={{
              disableDoubleClickZoom: !openMarker,
              zoom,
              center,
              leadsData,
              styles: mapStyles,
            }}
            onGoogleApiLoaded={({ map }) => {
              setMap(map);
              console.log("Map Has been loaded");
              map.addListener("click", handleMapClick);
            }}
            apiKey={"AIzaSyBljmQF0NelnWV5WFKQuRqGtIFqERkPWX4"}
            events={[
              {
                name: "onClick",
                handler: () => {
                  setOpenMarker(null);
                  return true;
                },
              },
            ]}
            onChange={handleChange}
          >
            {clusters?.map((item) => {
              const leaves = item.id
                ? supercluster
                    ?.getLeaves(item.id, 500)
                    .map((f) => f.properties) ?? []
                : [item.properties];

              return (
                <Markers
                  lat={item.geometry.coordinates[1]}
                  lng={item.geometry.coordinates[0]}
                  count={leaves.length}
                  type={
                    leaves.length == 1 ? getLeadColor(leaves[0]) : undefined
                  }
                  key={item.id}
                  onOpenStateChanged={() => {
                    setOpenMarker({
                      coordinates: item?.geometry?.coordinates,
                      items: leaves,
                    });
                    const data = map?.panTo({
                      lat: item?.geometry?.coordinates[1],
                      lng: item?.geometry?.coordinates[0],
                    });
                    return data;
                  }}
                />
              );
            })}
            {openMarker && (
              <OpenMarker
                key={
                  openMarker.items.map((item) => item.id).join("-") ||
                  "no-items"
                }
                lat={openMarker.coordinates[1]}
                lng={openMarker.coordinates[0]}
                items={openMarker.items}
                openMarker={openMarker}
                setOpenMarker={setOpenMarker}
                OpenMarker={OpenMarker}
                handleGetDashboardCount={handleGetDashboardCount}
                setZoom={setZoom}
              />
            )}
          </GoogleMap>
        </div>
        <div className="icon-alignment" onClick={handleFullScreen}>
          <FullScreenIcon />
        </div>
      </div>
      {isMobileFullScreen && (
        <MobileMapFullScreen
          isOpen={isMobileFullScreen}
          onClose={() => setIsMobileFullScreen(false)}
          children={
            <div className={`map-container mobile-fullscreen ${classNameMap}`}>
              <GoogleMap
                defaultZoom={zoom}
                defaultCenter={customCenter}
                center={center}
                options={{
                  disableDoubleClickZoom: !openMarker,
                  zoom,
                  center,
                  leadsData,
                  styles: mapStyles,
                }}
                onGoogleApiLoaded={({ map }) => {
                  setMap(map);
                  map.addListener("click", handleMapClick);
                }}
                apiKey={"AIzaSyBljmQF0NelnWV5WFKQuRqGtIFqERkPWX4"}
                events={[
                  {
                    name: "onClick",
                    handler: () => {
                      setOpenMarker(null);
                      return true;
                    },
                  },
                ]}
                onChange={handleChange}
              >
                {clusters?.map((item) => {
                  const leaves = item.id
                    ? supercluster
                        ?.getLeaves(item.id, 500)
                        .map((f) => f.properties) ?? []
                    : [item.properties];

                  return (
                    <Markers
                      lat={item.geometry.coordinates[1]}
                      lng={item.geometry.coordinates[0]}
                      count={leaves.length}
                      type={
                        leaves.length == 1 ? getLeadColor(leaves[0]) : undefined
                      }
                      key={item.id}
                      onOpenStateChanged={() => {
                        setOpenMarker({
                          coordinates: item?.geometry?.coordinates,
                          items: leaves,
                        });
                        const data = map?.panTo({
                          lat: item?.geometry?.coordinates[1],
                          lng: item?.geometry?.coordinates[0],
                        });
                        return data;
                      }}
                    />
                  );
                })}
                {openMarker && (
                  <OpenMarker
                    key={
                      openMarker.items.map((item) => item.id).join("-") ||
                      "no-items"
                    }
                    lat={openMarker.coordinates[1]}
                    lng={openMarker.coordinates[0]}
                    items={openMarker.items}
                    openMarker={openMarker}
                    setOpenMarker={setOpenMarker}
                    OpenMarker={OpenMarker}
                    handleGetDashboardCount={handleGetDashboardCount}
                    setZoom={setZoom}
                  />
                )}
              </GoogleMap>
            </div>
          }
        />
      )}
      {funnelSelectionData?.isFunnelMOdalOpen && (
        <LeadsValidForm
          isShowLeadModel={funnelSelectionData?.isFunnelMOdalOpen}
          locationData={funnelSelectionData?.locationData}
          handleAddLeadModalClose={() => {
            // Restore the previous map state when modal is closed if it exists
            if (funnelSelectionData.previousMapState && map) {
              const { center, zoom, bounds } = funnelSelectionData.previousMapState;
              if (center) map.setCenter(center);
              if (zoom) map.setZoom(zoom);
              if (bounds) map.fitBounds(bounds);
            }
            
            // Call handleGetDashboardCount to refresh the map data
            if (handleGetDashboardCount) {
              handleGetDashboardCount();
            }
            
            setFunnelSelectionData({
              isFunnelMOdalOpen: false,
              locationData: null,
              previousMapState: null
            });
          }}
          setIsLeadCreatedZoom={setIsLeadCreatedZoom}
          handleGetDashboardCount={handleGetDashboardCount}
        />
      )}
    </>
  );
};
